import { Phone, MessageCircle, FileText } from 'lucide-react';

export function StickyCall() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden">
      <div className="bg-white border-t border-background-200 shadow-lg flex items-stretch">
        <a
          href="tel:+3280020410"
          className="flex-1 flex items-center justify-center gap-1.5 py-3 bg-accent-500 hover:bg-accent-600 text-white text-sm font-semibold transition-colors"
        >
          <Phone className="w-4 h-4" />
          <span className="whitespace-nowrap">Appeler</span>
        </a>
        <a
          href="https://wa.me/32475585219"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex items-center justify-center gap-1.5 py-3 bg-success-500 hover:bg-success-600 text-white text-sm font-semibold transition-colors"
        >
          <MessageCircle className="w-4 h-4" />
          <span className="whitespace-nowrap">WhatsApp</span>
        </a>
        <Link
          to="/contact/"
          className="flex-1 flex items-center justify-center gap-1.5 py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-semibold transition-colors"
        >
          <FileText className="w-4 h-4" />
          <span className="whitespace-nowrap">Devis</span>
        </Link>
      </div>
    </div>
  );
}